import { routerPostCall } from '../../axios';

export const getQuotationEmailURL = `/accounts/quote/sendEmail`;
const getQuotationEmail = (state, params) => {
    const url = getQuotationEmailURL;
    return routerPostCall(state, url, params);
};
export default { getQuotationEmail };
